<template>
  <b-container fluid class="mt-50">
    <b-row>
      <b-col cols="6" md="3" v-for="(card, index) in cards" :key="index">
        <app-card :data="card" />
      </b-col>
    </b-row>
    <b-row class="bg-white my-3">
      <b-col cols="12" lg="6">
        <graph-data-based
          :axisAndSeries="axisAndSeries"
          :data="graphData"
          :max="max + 2"
        />
      </b-col>
      <b-col cols="12" lg="6">
        <graph-radar />
      </b-col>
    </b-row>
    <b-row class="my-3 bg-white">
      <b-col cols="12" md="6">
        <app-table :data-array="array" :fields="fields"     title="Top 10 ativos mais vulneráveis" />
      </b-col>
      <b-col cols="12" md="6">
        <app-table :data-array="array" :fields="fields"     title="Top 10 vulnerabilidades" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mixins } from "@/mixins/mixins";
import appCard from "@/components/lokiDashboard/_cards";
import fnGenerics from "@/mixins/loki/functions/generic";
import graphDataBased from "@/components/graphs/_dataBased";
import graphRadar from "@/components/graphs/_radarChart";
export default {
  components: { appCard, graphDataBased, graphRadar },
  mixins: [mixins, fnGenerics],
  metaInfo: {
    title: "GV Dashboard",
    titleTemplate: "%s | Odin",
  },
  data() {
    return {
      axisAndSeries: [
        { field: "baixo", name: "Baixo", opposite: true, geometric: "circle" },
        {
          field: "medio",
          name: "Médio",
          opposite: false,
          geometric: "triangle",
        },
        {
          field: "alto",
          name: "Alto",
          opposite: false,
          geometric: "rectangle",
        },
        {
          field: "critico",
          name: "Critico",
          opposite: false,
          geometric: "pipe",
        },
      ],
      graphData: [],
      max: 0,
      cards: [
        {
          number: 0,
          title: "XPTO 1",

          style: {
            backgroundColor: this.getName("findings").color,
          },
          image: this.getName("findings").image,
        },
        {
          number: 0,
          title: "XPTO 2",

          style: {
            backgroundColor: this.getName("domain").color,
          },
          image: this.getName("domain").image,
        },
        {
          number: 0,
          title: "XPTO 3",
          style: {
            backgroundColor: this.getName("vips").color,
          },
          image: this.getName("vips").image,
        },
        {
          number: 0,
          title: "XPTO 4",
          style: {
            backgroundColor: this.getName("takedowns").color,
          },
          image: this.getName("takedowns").image,
        },
      ],
      array: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "name", label: "Nome" },

        { key: "status", label: "Status" },
        { key: "created", label: "Data De Criação" },
        {
          key: "actions",
          label: "Ações",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.chartdiv {
  width: 100%;
  height: 500px;
}
</style>